import Pagination from "@/components/pagination/pagination";
import { Items } from "@/components/items/items";
import { SortDropDown } from "@/components/sortDropdown/sortDropdown";

export const CategoryPage = ({
  category,
  itemTemplate = "Image Focused",
  items = [],
  pageSize,
  currentPage,
  totalPages,
  totalItemCount,
  isSimpleStorefront,
  isRetailMerchant,
}: any) => {
  return (
    <div className="flex-1 flex flex-col px-6 sm:px-12 pb-12 pt-6">
      <div className="flex flex-col sm:flex-row w-full justify-between gap-4 mb-4">
        <p className="font-semibold text-[30px] leading-[45px]">
          {category.name}
        </p>
        {!isSimpleStorefront && <SortDropDown />}
      </div>
      {items.length > 0 ? (
        <Items {...{ itemTemplate, items, isRetailMerchant }} />
      ) : (
        <p className="text-[20px] text-[#4B5563] font-normal">
          No items for sale in this category.
        </p>
      )}
      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        itemCount={items.length}
        totalItemCount={totalItemCount}
      />
    </div>
  );
};
